import { DefaultButton, Dialog, FontIcon, FontWeights, mergeStyles, mergeStyleSets, MessageBar, MessageBarType, Modal, Panel, PanelType, PrimaryButton, ProgressIndicator, Stack, Text, useTheme } from '@fluentui/react';
import * as React from 'react';
import { IAttendeeRegistrationListItem, IAttendeeRegistrationListItemSelected } from '../../../../Models/Event/IAttendeeRegistrationListItem';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { IInvoiceApi } from '../../../../Services/API/Invoice/IInvoiceApi';
import { CreateInvoiceFromRegistrationView } from './CreateInvoiceFromRegistrationView';
import * as Services from '../../../../Services/Services';
import { useBoolean } from '@fluentui/react-hooks';
import { ICreateInvoiceFromRegistration } from '../../../../Models/Invoice/ICreateInvoiceFromRegistration';
import { IUserProfile } from '../../../../Models/Profile/IUserProfile';
import { IUserInvoiceInfo } from '../../../../Models/Admin/IUserInvoiceInfo';

interface IAttendeeRegistrationDetailProps {
    item: IAttendeeRegistrationListItemSelected;
    eventName: string;
    semester: number;
    isOpen: boolean;
    close: () => void;
    refresh: (invoiceId: number) => void;
    profile: IUserProfile;
    userInvoiceInfo: IUserInvoiceInfo;
}


export const CreateInvoiceFromRegistration: React.FunctionComponent<IAttendeeRegistrationDetailProps> = (props) => {

    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();
    const [invoice, setInvoice] = React.useState<ICreateInvoiceFromRegistration>({ semester: 0, registrationId: 0, text: "", value: 0 })
    const theme = useTheme();

    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });

    const propertyChanged = (key: string, value: any) => {
        if (invoice) {
            setInvoice({ ...invoice, [key]: value });
        }
    }

    const getPrice = (item: IAttendeeRegistrationListItem, semester: number): number => {
        switch (semester) {
            case 0: return item.price - (item.priceInvoiceTotal ? item.priceInvoiceTotal : 0);
            case 1: return item.firstSemesterPrice - (item.firstSemesterPriceInvoiceTotal ? item.firstSemesterPriceInvoiceTotal : 0);
            case 2: return item.secondSemesterPrice - (item.secondSemesterPriceInvoiceTotal ? item.secondSemesterPriceInvoiceTotal : 0);
            default: return 0;
        }
    }



    React.useEffect(() => {
        if (props.item) {
            setInvoice({
                semester: props.semester,
                registrationId: props.item.id,
                text: props.eventName,
                value: getPrice(props.item, props.semester),
                sendByEmail: true,
                email: props.userInvoiceInfo.billingEmail
            });
        }
    }, [props.item])

    const sendViaEmail = async (invoices: number[]) => {
        setIsLoading.setTrue();

        const invoiceApi = Services.ServicesProvider.GetService<IInvoiceApi>(Services.InvoiceApi);
        const result = await invoiceApi.sendInvoiceEmail(invoices);
        if (result.isSuccess) {
            setStatusMessage({ message: "Faktura byla úspěšně odeslána emailem", type: MessageBarType.success });
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const createInvoice = async (invoice: ICreateInvoiceFromRegistration) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);

        const invoiceApi = Services.ServicesProvider.GetService<IInvoiceApi>(Services.InvoiceApi);

        const invoiceResult = await invoiceApi.createInvoiceFromRegistration([invoice]);

        if (invoiceResult.isSuccess && invoiceResult.data) {
            setStatusMessage({ message: invoiceResult.message, type: MessageBarType.success });
            props.refresh(invoiceResult.data[0]);
            if (invoice.sendByEmail === true) {
                await sendViaEmail(invoiceResult.data);
            }
            props.close();
        }
        else {
            setStatusMessage({ message: invoiceResult.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    return (
        <>
            {props.isOpen ?

                <CreateInvoiceFromRegistrationView
                    profile={props.profile}
                    item={invoice}
                    propertyChanged={propertyChanged}
                    isOpen={props.isOpen}
                    close={props.close}
                    createInvoice={() => { createInvoice(invoice) } }
                />
            :null}
        </>)

}